import { cx } from "@linaria/core";
import type { ReactNode } from "react";
import React from "react";

import * as styles from "./styles/LayoutBoundary";

export function LayoutBoundary({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}): ReactNode {
  return <div className={cx(styles.boundaryCls, className)}>{children}</div>;
}
